import React from 'react';
import ReactApexChart from 'react-apexcharts';
import moment from "moment";


const PrimerPosVodafoneReportChart = ({data, grouping, height = 340, unitLabel = 'MiB', title = 'Data Usage'}) => {
    const isDaily = grouping === 'day';
    const nf = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 });
    const uploadSeries = data.map(p => {return {x: p.period, y: p.uploadMB}});
    const downloadSeries = data.map(p => {return {x: p.period, y: p.downloadMB}});
    const totalSeries = data.map(p => {return {x: p.period, y: p.totalMB}});
    const totals = {
        upload: +data.reduce((sum, p) => sum + (p.uploadMB || 0), 0).toFixed(2),
        download: +data.reduce((sum, p) => sum + (p.downloadMB || 0), 0).toFixed(2),
        total: +data.reduce((sum, p) => sum + (p.totalMB || 0), 0).toFixed(2)
    };
    const options = {
        chart: {
            id: 'usage-area',
            type: 'area',
            stacked: false,
            animations: { enabled: true, easing: 'easeinout', speed: 450 },
            toolbar: {
                show: true,
                tools: {
                    download: true,
                    selection: true,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true
                }
            },
            zoom: { enabled: true }
        },
        stroke: { curve: 'smooth', width: 2 },
        dataLabels: { enabled: false },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 0.2,
                opacityFrom: 0.4,
                opacityTo: 0.1,
                stops: [0, 90, 100]
            }
        },
        grid: { borderColor: '#eee' },
        legend: { show: true, position: 'top',   selected: {Total: true, Upload: false, Download: false} },
        title: { text: title, style: { fontWeight: 600 } },
        xaxis: {
            labels: {formatter: (val) => moment(val, isDaily ? "YYYY-MM-DD" : "YYYY-MM").format(isDaily ? "DD-MM" : "MMM-YYYY")},
            tickAmount: isDaily ? Math.ceil(data.length / 2) : undefined,
            tooltip: { enabled: false }
        },
        yaxis: {
            labels: {
                formatter: val => `${nf.format(val)} ${unitLabel}`
            },
            min: 0,
            forceNiceScale: true
        },
        tooltip: {
            shared: true,
            x: { format: isDaily ? 'dd MMM yyyy' : 'MMM yyyy' },
            y: {
                formatter: val => `${nf.format(val)} ${unitLabel}`,
                title: { formatter: seriesName => seriesName }
            }
        },
        noData: { text: 'No data' }
    };

    const series = [
        { name: 'Download', data: downloadSeries, hidden: true },
        { name: 'Upload', data: uploadSeries, hidden: true },
        { name: 'Total', data: totalSeries, hidden: false }
    ];

    return (
        <div style={{ width: '100%' }}>
            {/* Chart */}
            {data.length === 0 ? (
                <div style={{ padding: 24, textAlign: 'center', color: '#666' }}>
                    No data
                </div>
            ) : (
                <>
                    <ReactApexChart
                        options={options}
                        series={series}
                        type="area"
                        height={height}
                    />
                    <div
                        style={{
                            marginTop: 16,
                            display: 'flex',
                            justifyContent: 'space-around',
                            background: '#f9f9f9',
                            borderRadius: 8,
                            padding: '12px 0',
                            fontWeight: 500
                        }}>
                        <div style={{ color: '#0070f3' }}>
                            Total Download: {nf.format(totals.download)} {unitLabel}
                        </div>
                        <div style={{ color: 'green' }}>
                            Total Upload: {nf.format(totals.upload)} {unitLabel}
                        </div>
                        <div style={{ color: 'orange' }}>
                            Total Consumption: {nf.format(totals.total)} {unitLabel}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default React.memo(PrimerPosVodafoneReportChart);
